import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

const PaginationContext = createContext(null);

export const usePaginationContext = () => {
	const context = useContext(PaginationContext);
	if (!context) {
		throw new Error(
			'usePaginationContext must be used within PaginationProvider'
		);
	}
	return context;
};

export const PaginationProvider = ({ children, value }) => {
	return (
		<PaginationContext.Provider value={value}>
			{children}
		</PaginationContext.Provider>
	);
};

PaginationProvider.propTypes = {
	children: PropTypes.node.isRequired,
	value: PropTypes.shape({
		totalCount: PropTypes.number.isRequired,
		allData: PropTypes.arrayOf(
			PropTypes.shape({
				location: PropTypes.shape({
					name: PropTypes.string
				}),
				displayType: PropTypes.string
			})
		).isRequired,
		onPageChange: PropTypes.func.isRequired,
		resetTriggers: PropTypes.arrayOf(
			PropTypes.oneOfType([
				PropTypes.string,
				PropTypes.number,
				PropTypes.bool
			])
		),
		currentPage: PropTypes.number
	}).isRequired
};
